import { FlightService } from "../../services/flights/flight.service"

export default function updatelastseen(flightid) {
    FlightService.updateFlightLastSeen(flightid);
}